export class UserAgent {
    public static isOldVersionOfEdge = window.navigator.userAgent.indexOf("Edge") > -1;
    public static isFirefox = window.navigator.userAgent.indexOf("Firefox") > 0;
}